<template>
  <pop-up-window :show="show" :showClose="false" @close="close">
    <template #header>Adding status</template>
    <template #content>
      <div class="flex flex-col items-end">
        <div class="w-full">
          <div ref="statusTable"></div>
        </div>
        <button
          class="btn shadow-md mr-2 mt-2 nymus-orange color-white"
          @click="$emit('close')"
        >
          Close
        </button>
      </div>
    </template>
  </pop-up-window>
</template>

<script>
import PopUpWindow from "@/components/PopUp.vue";
import { TabulatorFull as Tabulator } from "tabulator-tables";

export default {
  components: { PopUpWindow },
  props: {
    show: Boolean,
    statuses: Object,
    ingestionData: Array,
  },
  emits: ["close"],
  data() {
    return {
      columns: [
        {
          title: "",
          field: "status",
          hozAlign: "center",
          width: "8%",
          headerSort: false,
          formatter(cell) {
            if (cell.getData().status === "success") {
              return `<div  class="font-medium whitespace-nowrap salary billing">
                                  <span class="material-icons-outlined" style="color: #91c714">check_circle</span>
                              </div>`;
            } else {
              return `<div  class="font-medium whitespace-nowrap salary billing">
                                   <span class="material-icons-outlined" style="color: #d32929">highlight_off</span>
                              </div>`;
            }
          },
        },
        {
          title: "identifier",
          field: "identifier",
          hozAlign: "center",
          width: "35%",
          headerSort: false,
        },
        {
          title: "message",
          field: "message",
          hozAlign: "left",
          headerSort: false,
        },
      ],
    };
  },

  mounted() {
    this.initTabulator();
  },
  methods: {
    async initTabulator() {
      try {
        this.table = await new Tabulator(this.$refs["statusTable"], {
          headerSortElement:
            "<span><i class='noSorting'></i><i class='arrow-up'></i> <i class='arrow-down'></i></span>",
          layout: "fitColumns",
          columnDefaults: {
            resizable: false,
          },
          autoResize: true,
          locale: false,

          resizableColumnFit: true,
          data: this.statuses,
          columns: this.columns,
        });
      } catch (error) {
        this.$store.commit("displayErrorAlertText", "Error: " + error.message, {
          root: true,
        });
        this.$store.commit("displayErrorAlert", true, { root: true });
      }
    },
  },
};
</script>
